export enum EDataTableType {
  TotalCount,
  DataItem,
  Size,
  SortDirection,
}
